import apiClient from '../api/apiClient';

function unwrap(res) {
  const body = res?.data;
  if (body && typeof body === 'object' && 'data' in body) return body.data;
  return body;
}

export const SHARE_REQUEST_STATUSES = ['PENDING', 'APPROVED', 'REJECTED', 'FULFILLED'];

const shareRequestService = {
  getAdminShareRequests: async (params = {}) => {
    const defaultParams = {
      page: 1,
      limit: 10,
      ...params,
    };
    const response = await apiClient.get('/api/v1/share-requests/admin', { params: defaultParams });
    return unwrap(response);
  },
};

export default shareRequestService;
